import React from 'react';
import img1 from './assets/img1.webp';
import img2 from './assets/Shankhabhishekam.webp';
import img3 from './assets/SoulKirtan.webp';
import img4 from './assets/SpiritualDiscourses.webp';
import img5 from './assets/Pushpabhishekam.webp';
import Kalash from './assets/Kalash.webp';
import utti from './assets/utti.webp';

import styles from './JCarousel.module.css';

const cards = [
  {
    img: img1,
    title: "Divine Darshan",
    text: "Behold Lord Sri Radha Shyamsundar in His most exquisite and opulent form on this sacred day.",
    alt: ""
  },
  {
    img: img3,
    title: "Soul-Stirring Kirtans",
    text: " Engage your soul in the uplifting waves of kirtans and bhajans led by senior Vaishnavas.",
    alt: "Shankabhishekam Image"
  },
  {
    img: img2,
    title: "Grand Maha Shankhabhishekam",
    text: "Witness the ceremonial bathing of the Lord with sanctified conch water during the auspicious Maha Shankhabhishekam.",
    alt: "Shankabhishekam Image"
  },
  {
    img: img4,
    title: "Spiritual Discourses",
    text: "Gain deep spiritual insights from renowned preachers narrating Krishna's pastimes.",
    alt: "Pushpabhishekam Image"
  },
  {
    img: img5,
    title: "Maha Pushpabhishekam",
    text: "Experience a breathtaking offering of fragrant flowers showered upon the Lord.",
    alt: "Kirtans Image"
  },
  {
    img: Kalash,
    title: "Kalash Abhisheka Seva",
    text: "Participate in the divine Kalash Abhishekam by offering sanctified waters with devotion.",
    alt: "Kalash Abhishekaseva Image"
  },
  {
    img: utti,
    title: "Utti Mahotsav Competitions",
    text: " Celebrate Krishna's childhood mischief with thrilling Utti-breaking competitions that captivate devotees of all ages.",
    alt: "Utti competition Image"
  }
];

const JCarousel = () => {
  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carouselTrack}>
        {[...cards, ...cards].map((card, i) => (
          <div key={i} className={styles.card}>
            <img src={card.img} alt={card.alt} />
            <h3>{card.title}</h3>
            <p>{card.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JCarousel;
